import { createSelector } from 'reselect'
import jwtSelector from '../app/jwtSelector'

export default createSelector(jwtSelector, (jwt) => ({ jwt }))
